import React from 'react';
import OfferDetailsPage from './OfferDetailsPage';
import OrderDetailsPage from './OrderDetailsPage';

export default function EntityDetailsPage({ order, ...props }) {
  const DetailsPage = order?.type === 'Offer' ? OfferDetailsPage : OrderDetailsPage;
  return <DetailsPage order={order} {...props} />;
}
